// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__NaQcd","preloader":"Loader_preloader__Fds7Q","spin":"Loader_spin__T9G4o"};